import { useUnits } from '@/modules/company';
import { usePhoneLines } from './api';
import { linhaDaUnidade } from './components/unit-status';

export function useWhatsappUnit(unitId: string | undefined) {
  const units = useUnits();
  const lines = usePhoneLines();

  const unidade = units.data?.data.find((item) => item.id === unitId) ?? null;

  return {
    carregando: units.isLoading || lines.isLoading,
    unidade,
    linha: unidade ? linhaDaUnidade(lines.data?.data ?? [], unidade.id) : null,
  };
}
